import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { UserClientsComponent } from './userclients.component';

import { UserClientsRoutingModule } from './userclient-routing.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UserClientsRoutingModule
    ],
    declarations: [
        UserClientsComponent,
    ],
    providers: [
    ]
})
export class UserClientsModule { }



// WEBPACK FOOTER //
// ./src/app/userclients/userclients.module.ts